export default __webpack_public_path__ + "static/media/DispositifDisplayImage.80fd18bd.svg";